import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { BarChartComponent } from "./partial/BarChart";
import { useState } from "react";
import TabelRekap from "./partial/TabelRekap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getMasterSystem } from "@/services/getData";
import { useTahun } from "@/hooks/useTahun";

export default function DashboardOperatorInternasionalPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const menuParams = searchParams.get("menu") || "GRAFIK";
  const { selectedTahun } = useTahun();

  const [activeMenu, setActiveMenu] = useState<"GRAFIK" | "DATA">(
    menuParams as "GRAFIK" | "DATA",
  );

  const { data: system } = useQuery({
    queryKey: ["masterSystem"],
    queryFn: getMasterSystem,
  });

  const tahun =
    selectedTahun?.label ||
    (system ? system[0]?.tahun_aktif : new Date().getFullYear());

  return (
    <div>
      <h1 className="mb-5 text-2xl font-bold">Dashboard</h1>
      <section className="mb-3 grid grid-cols-2 gap-3">
        <Card
          className={`${
            activeMenu === "GRAFIK"
              ? "bg-primary text-white"
              : "cursor-pointer hover:bg-secondary"
          }`}
          onClick={() => {
            setActiveMenu("GRAFIK");
            navigate("/operator-internasional/dashboard?menu=GRAFIK");
          }}
        >
          <CardHeader>
            <CardTitle>Grafik</CardTitle>
            <CardDescription
              className={`${
                activeMenu === "GRAFIK" ? "text-muted" : "text-muted-foreground"
              } `}
            >
              Tahun {tahun}
            </CardDescription>
          </CardHeader>
        </Card>
        <Card
          className={`${
            activeMenu === "DATA"
              ? "bg-primary text-white"
              : "cursor-pointer hover:bg-secondary"
          }`}
          onClick={() => {
            setActiveMenu("DATA");
            navigate("/operator-internasional/dashboard?menu=DATA");
          }}
        >
          <CardHeader>
            <CardTitle>Data</CardTitle>
            <CardDescription
              className={`${
                activeMenu === "DATA" ? "text-muted" : "text-muted-foreground"
              } `}
            >
              Tahun {tahun}
            </CardDescription>
          </CardHeader>
        </Card>
      </section>
      {activeMenu === "GRAFIK" && (
        <section>
          <div className="mb-3 grid grid-cols-2 gap-3">
            {/* <AreaChartComponent /> */}
          </div>
          <BarChartComponent tahun={tahun} />
        </section>
      )}

      {activeMenu === "DATA" && <TabelRekap tahun={tahun} />}
    </div>
  );
}
